import { GetLanguageList } from "@/typescript/Services/Api/LanguageApi";
import { Locale } from "@varlet/ui";
import { defineStore } from "pinia";

export const useLocaleStore = defineStore('locale', {
    state: () => ({
        locale: 'en-US' as string,
        lanaguageList: [] as DB.Language[]
    }),
    persist: [
        {
            pick: ['locale'],
            storage: localStorage,
        }
    ],
    getters: {
        /**
         * 获取当前的语言
         * @param state 
         * @returns 
         */
        GetLocale(state): string {
            return state.locale;
        },
        /**
         * 获取语言列表
         */
        GetLanguageList(state): DB.Language[] {
            return state.lanaguageList;
        }
    },
    actions: {
        /**
         * 加载语言
         */
        async LoadLanguageAsync() {

            const resp = await GetLanguageList();
            if (resp.CheckIsOk()) {
                this.lanaguageList = resp.data!;
            }
            else {
                this.lanaguageList = [];
            }
        },
        /**
         * 设置语言
         * @param v 
         */
        SetLocale(v: string) {
            this.locale = v;
            Locale.use(v);
        }
    }
});